import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import {
  createWorkHoursUrl,
  updateWorkHoursUrl,
  deleteWorkHoursUrl,
} from "../../../../Library/URLs";
// import { CircularProgress } from "@mui/material";
import axios from "axios";
import { v4 as uuid } from "uuid";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import Multiselect from "multiselect-react-dropdown";
import { useParams } from "react-router-dom";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    width: "552px",
    fontFamily: "Quicksand",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
    fontFamily: "Quicksand",
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle
      sx={{ m: 0, p: 2, fontFamily: "Quicksand, sans-serif" }}
      {...other}
    >
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export const CreateWorkHour = ({ open, handleClose, updateWorkHour }) => {
  const unique_id = uuid();
  const { User } = useSelector((state) => state.payroll);
  const { companyid } = useParams();
  // const proxyEmployee = useSelector((state) => state.payroll.Proxy);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [hours, setHours] = useState("");
  const [dayType, setDayType] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [customList, setCustomList] = useState("");

  const daysOptions = [
    { label: "Sunday", value: "Sunday" },
    { label: "Monday", value: "Monday" },
    { label: "Tuesday", value: "Tuesday" },
    { label: "Wednesday", value: "Wednesday" },
    { label: "Thursday", value: "Thursday" },
    { label: "Friday", value: "Friday" },
    { label: "Saturday", value: "Saturday" },
  ];
  // const [time, setTime] = useState({
  //   start: "",
  //   end: ""
  // })

  const onSelect = (selectedList, selectedItem) => {
    // console.log('onSelected',selectedList,selectedItem)
    setSelectedValue(selectedList);
    console.log("pops", selectedList);
    // console.log('onSelected',SelectedEmployee)
    FilterEmployeeID(selectedList);
  };

  const FilterEmployeeID = (selectedList) => {
    const k = selectedList.map((item, index) => item.value);
    const Pipe = k.join("|");
    setCustomList(Pipe);
  };

  const onRemove = (selectedList, removedItem) => {
    //  console.log('onRemove',selectedList,removedItem)
    FilterEmployeeID(selectedList);
  };

  const createWorkHours = async () => {
    // console.log('all employee API is call')
    setIsLoading(true);
    const raw = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      day_type: dayType === "Custom" ? customList : dayType,
      start_time: startTime,
      end_time: endTime,
      hours: hours,
    };
    console.log("first");
    await axios
      .post(createWorkHoursUrl, raw)
      .then((res) => {
        setIsLoading(false);
        if (res.data.success === true) {
          toast.success(res.data?.data);
          // setFormData(initState);
          closeDialog();
          updateWorkHour();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log("error" + err.message);
        toast.error("Request Failed");
        setIsLoading(false);
      });
  };

  const handleDifference = (start, end) => {
    if (start === "" || end === "") {
      return;
    } else {
      const startMoment = moment(start, "HH:mm");
      const endMoment = moment(end, "HH:mm");
      const difference = endMoment.diff(startMoment, "hours");
      setHours(difference);
    }
  };

  const closeDialog = () => {
    handleClose();
    setStartTime("");
    setEndTime("");
    setHours("");
    setDayType("");
    setSelectedValue("");
    setCustomList("");
  };

  const dashboardTheme = window.localStorage.getItem("theme");

  return (
    <BootstrapDialog
      onClose={closeDialog}
      aria-labelledby="customized-dialog-title"
      open={open}
      // maxWidth={'sm'}
      // fullWidth={true}
      className="Dialog_Wrap"
    >
      <BootstrapDialogTitle id="customized-dialog-title" onClose={closeDialog}>
        <div className="Name">Create Work Hour</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="">
          <div className="Content_Wrap">
            <div className="Box">
              <label htmlFor="">Day Type</label>
              <select
                name="dayType"
                value={dayType}
                onChange={(e) => setDayType(e.target.value)}
                id=""
              >
                <option value="" hidden>
                  Choose day type
                </option>
                <option value="Weekday">Weekday</option>
                <option value="Weekend">Weekend</option>
                <option value="Custom">Custom Day(s)</option>
              </select>
            </div>
          </div>
          <div className="Content_Wrap">
            {dayType === "Custom" && (
              <div className="Box_Multi" style={{ marginBottom: "1rem" }}>
                <label
                  style={{ fontSize: "13px", lineHeight: "16px" }}
                  htmlFor=""
                >
                  Custom Day(s)
                </label>
                <Multiselect
                  showArrow={true}
                  closeOnSelect={true}
                  options={daysOptions} // Options to display in the dropdown
                  selectedValues={selectedValue} // Preselected value to persist in dropdown
                  onSelect={onSelect} // Function will trigger on select event
                  onRemove={onRemove} // Function will trigger on remove event
                  displayValue="value" // Property name to display in the dropdown options
                  avoidHighlightFirstOption={true}
                  showCheckbox={true}
                />
              </div>
            )}
          </div>
          <div className="Content_Wrap">
            <div className="Box">
              <label htmlFor="">From</label>
              <input
                name="startTime"
                value={startTime}
                onChange={(e) => {
                  setStartTime(e.target.value);
                  handleDifference(e.target.value, endTime);
                }}
                type="time"
              />
            </div>
            <div className="Box">
              <label htmlFor="">To</label>
              <input
                name="endTime"
                value={endTime}
                onChange={(e) => {
                  setEndTime(e.target.value);
                  handleDifference(startTime, e.target.value);
                }}
                type="time"
              />
            </div>
            <div className="Box">
              <label htmlFor="">Work Hours</label>
              <input
                name="hours"
                value={hours}
                readOnly
                // onChange={(e) =>
                //   setFormData({ ...formData, hours: e.target.value })
                // }
                type="text"
              />
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Pay_Item_Btn_Action_Wrapper">
          <div className="Btn" onClick={handleClose}>
            Cancel
          </div>

          <div
            className="Btn"
            onClick={createWorkHours}
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
          >
            {isLoading === true ? (
              <span className="spinner-border spinner-grow-sm" />
            ) : (
              "Create"
            )}
          </div>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const EditWorkHour = ({
  open,
  handleClose,
  updateWorkHourList,
  work_hour,
}) => {
  const unique_id = uuid();
  const { User } = useSelector((state) => state.payroll);
  const { companyid } = useParams();
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [hours, setHours] = useState("");
  const [dayType, setDayType] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [customList, setCustomList] = useState("");

  const daysOptions = [
    { label: "Sunday", value: "Sunday" },
    { label: "Monday", value: "Monday" },
    { label: "Tuesday", value: "Tuesday" },
    { label: "Wednesday", value: "Wednesday" },
    { label: "Thursday", value: "Thursday" },
    { label: "Friday", value: "Friday" },
    { label: "Saturday", value: "Saturday" },
  ];
  // const [time, setTime] = useState({
  //   start: "",
  //   end: ""
  // })

  const onSelect = (selectedList, selectedItem) => {
    // console.log('onSelected',selectedList,selectedItem)
    setSelectedValue(selectedList);
    console.log("pops", selectedList);
    // console.log('onSelected',SelectedEmployee)
    FilterEmployeeID(selectedList);
  };

  const FilterEmployeeID = (selectedList) => {
    const k = selectedList.map((item, index) => item.value);
    const Pipe = k.join("|");
    setCustomList(Pipe);
  };

  const onRemove = (selectedList, removedItem) => {
    //  console.log('onRemove',selectedList,removedItem)
    FilterEmployeeID(selectedList);
  };

  useEffect(() => {
    setStartTime(work_hour?.start_time);
    setEndTime(work_hour?.end_time);
    setHours(work_hour?.hours);
    if (work_hour?.dayType !== "Weekend" || work_hour?.day_type !== "Weekday") {
      setSelectedValue(
        work_hour?.day_type?.split("|")?.map((item) => {
          return { value: item, label: item };
        })
      );
      setCustomList(work_hour?.day_type);
      setDayType("Custom");
    }
    // eslint-disable-next-line
  }, [work_hour]);

  const updateWorkHour = async () => {
    // console.log('all employee API is call')
    setIsLoading(true);
    const raw = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      day_type: dayType === "Custom" ? customList : dayType,
      start_time: startTime,
      end_time: endTime,
      hours: hours,
      employee_work_hour_id: work_hour?.id,
    };
    await axios
      .post(updateWorkHoursUrl, raw)
      .then((res) => {
        setIsLoading(false);
        if (res.data.success === true) {
          toast.success(res.data?.data);
          closeDialog();
          updateWorkHourList();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log("error" + err.message);
        toast.error("Request Failed");
        setIsLoading(false);
      });
  };

  const handleDifference = (start, end) => {
    if (start === "" || end === "") {
      return;
    } else {
      const startMoment = moment(start, "HH:mm");
      const endMoment = moment(end, "HH:mm");
      const difference = endMoment.diff(startMoment, "hours");
      setHours(difference);
    }
  };

  const closeDialog = () => {
    handleClose();
    setStartTime("");
    setEndTime("");
    setHours("");
    setDayType("");
    setSelectedValue("");
    setCustomList("");
  };

  const dashboardTheme = window.localStorage.getItem("theme");

  return (
    <BootstrapDialog
      onClose={closeDialog}
      aria-labelledby="customized-dialog-title"
      open={open}
      // maxWidth={'sm'}
      // fullWidth={true}
      className="Dialog_Wrap"
    >
      <BootstrapDialogTitle id="customized-dialog-title" onClose={closeDialog}>
        <div className="Name">Edit Work Hour</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="">
          <div className="Content_Wrap">
            <div className="Box">
              <label htmlFor="">Day Type</label>
              <select
                name="dayType"
                value={dayType}
                onChange={(e) => setDayType(e.target.value)}
                id=""
              >
                <option value="" hidden>
                  Choose day type
                </option>
                <option value="Weekday">Weekday</option>
                <option value="Weekend">Weekend</option>
                <option value="Custom">Custom Day(s)</option>
              </select>
            </div>
          </div>
          <div className="Content_Wrap">
            {dayType === "Custom" && (
              <div className="Box_Multi" style={{ marginBottom: "1rem" }}>
                <label
                  style={{ fontSize: "13px", lineHeight: "16px" }}
                  htmlFor=""
                >
                  Custom Day(s)
                </label>
                <Multiselect
                  showArrow={true}
                  closeOnSelect={true}
                  options={daysOptions} // Options to display in the dropdown
                  selectedValues={selectedValue} // Preselected value to persist in dropdown
                  onSelect={onSelect} // Function will trigger on select event
                  onRemove={onRemove} // Function will trigger on remove event
                  displayValue="value" // Property name to display in the dropdown options
                  avoidHighlightFirstOption={true}
                  showCheckbox={true}
                />
              </div>
            )}
          </div>
          <div className="Content_Wrap">
            <div className="Box">
              <label htmlFor="">From</label>
              <input
                name="startTime"
                value={startTime}
                onChange={(e) => {
                  setStartTime(e.target.value);
                  handleDifference(e.target.value, endTime);
                }}
                type="time"
              />
            </div>
            <div className="Box">
              <label htmlFor="">To</label>
              <input
                name="endTime"
                value={endTime}
                onChange={(e) => {
                  setEndTime(e.target.value);
                  handleDifference(startTime, e.target.value);
                }}
                type="time"
              />
            </div>
            <div className="Box">
              <label htmlFor="">Work Hours</label>
              <input
                name="hours"
                value={hours}
                readOnly
                // onChange={(e) =>
                //   setFormData({ ...formData, hours: e.target.value })
                // }
                type="text"
              />
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Pay_Item_Btn_Action_Wrapper">
          <div className="Btn" onClick={closeDialog}>
            Cancel
          </div>

          <div
            className="Btn"
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
            onClick={updateWorkHour}
          >
            {isLoading === true ? (
              <span className="spinner-border spinner-grow-sm" />
            ) : (
              "Update"
            )}
          </div>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const DeleteWorkHours = ({
  open,
  handleClose,
  updateWorkHourList,
  workHour,
}) => {
  const unique_id = uuid();
  const { User } = useSelector((state) => state.payroll);
  const { companyid } = useParams();

  const [isLoading, setIsLoading] = useState(false);

  const deleteWorkHour = async () => {
    // console.log('all employee API is call')
    setIsLoading(true);
    const raw = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      employee_work_hour_id: workHour,
    };
    await axios
      .post(deleteWorkHoursUrl, raw)
      .then((res) => {
        setIsLoading(false);
        if (res.data.success === true) {
          toast.success(res.data?.data);
          handleClose();
          updateWorkHourList();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log("error" + err.message);
        toast.error("Request Failed");
        setIsLoading(false);
      });
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      // maxWidth={'sm'}
      // fullWidth={true}
      className="Dialog_Wrap"
    >
      <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
        <div className="Name">Delete Work Hour</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div>
          <div className="Confirmation">Are you sure?</div>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Pay_Item_Btn_Action_Wrapper">
          <div className="Btn" onClick={handleClose}>
            Cancel
          </div>

          <div className="Btn Delete_Btn" onClick={deleteWorkHour}>
            {isLoading === true ? (
              <span className="spinner-border spinner-grow-sm" />
            ) : (
              "Delete"
            )}
          </div>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};
